import React from 'react';
import PropTypes from 'prop-types';
import * as S from './ProgressLine.styles';
import { PROGRESS_STATE } from '../../../utils/Constants';

const defaultValue = PROGRESS_STATE.DEFAULT;
const completedValue = PROGRESS_STATE.COMPLETED;

const ProgressLine = ({ progress, isLandscape }) => {
  const progressValidated =
    progress >= defaultValue && progress <= completedValue
      ? progress
      : progress > completedValue
      ? completedValue
      : defaultValue;

  return (
    <S.Wrapper isLandscape={isLandscape}>
      <S.ProgressLineComplete
        data-testid='progressLine'
        isLandscape={isLandscape}
        progress={progressValidated}
      />
    </S.Wrapper>
  );
};

ProgressLine.propTypes = {
  progress: PropTypes.number,
  isLandscape: PropTypes.bool,
};

ProgressLine.defaultProps = {
  progress: 0,
  isLandscape: false,
};
export default ProgressLine;
